exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.interview-image-wrapper[data-v-0d0c0b50] {\n  text-align: center;\n}\n.interview-image-wrapper img[data-v-0d0c0b50] {\n    width: 800px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d0c0b50","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/atoms/InterviewImage.vue
// module id = IQLi
// module chunks = 3